export default () => ({
  getToken: () => {
    return Promise.resolve('web_token');
  },
  onTokenRefresh: () => {
    return () => {};
  },
});
